class Header {
    constructor() {
        this.body = document.querySelector('body');
        this.toggleMenuMobileButton = document.querySelector('button[data-toggle-mobile-menu]');
        this.closeMenuMobileButton = document.querySelector('button[data-close-mobile-menu]');
        this.menuMobile = document.querySelector('[data-mobile-menu]');
        this.toggleMobileSubMenus = document.querySelectorAll('button[data-menu-sub-item]');
        this.closeMobileSubMenus = document.querySelectorAll('button[data-close-sub-menu]');
        this.mobileSubMenuAccordions = document.querySelectorAll('[data-sub-menu-accordion-context]');
        this.closeMobileSubMenuAccordions = document.querySelectorAll('button[data-close-sub-menu-accordion]');
        this.toggleDesktopSubMenus = document.querySelectorAll('button[data-header-toggle-menu]');
        this.topLevelMobileButtons = document.querySelectorAll('[data-top-level-mobile]');
        this.desktopSubMenus = document.querySelectorAll('[data-header-sub-menu]');
        this.announcementBar = document.getElementById('shopify-section-announcement-bar');
        this.stickyHeader = document.querySelector('sticky-header');
        this.headerBackdrop = document.querySelector('div[data-header-backdrop]');
        this.logoHeader = document.querySelector('[data-header-logo]');
        this.headerIcons = document.querySelector('[data-header-icons]');
        this.mobileSearchIcon = document.querySelector('[data-mobile-search-icon]');

        this.predictiveSearch = document.querySelector('predictive-search');
        this.predictiveSearchToggle = document.querySelectorAll('modal-opener[data-modal="#PredictiveSearch"]');
        this.predictiveSearchClose = document.querySelector('button[id=ModalClose-PredictiveSearch]');
        this.predictiveSearchModal = document.querySelector('modal-dialog[id=PredictiveSearch]');

        this.desktopBreakpoint = 1280;

        this.menuEventListeners();

        this.transparentHeaderCheck()
    }

    menuEventListeners () {
        this.toggleMenuMobileButton.addEventListener('click', () => {
            this.toggleMobileMenu(this.menuMobile);
            this.toggleMobileBodyOverflow();
        })

        this.closeMenuMobileButton.addEventListener('click', () => {
            this.toggleMobileMenu(this.menuMobile);
            this.toggleMobileBodyOverflow();
        })

        this.toggleMobileSubMenus.forEach(toggle => {
            toggle.addEventListener('click', (event) => {
                if (window.innerWidth < this.desktopBreakpoint) {
                    const menu = event.target.nextElementSibling;
                    this.toggleMobileTopLevelMenu(menu, toggle);
                }
            })
        })

        this.closeMobileSubMenus.forEach(close => {
            close.addEventListener('click', (event) => {
                const menu = event.target.closest('div[data-sub-menu]');
                this.toggleMobileMenu(menu);
            })
        })

        this.mobileSubMenuAccordions.forEach((mobileSubMenuAccordion, index) => {
            const trigger = mobileSubMenuAccordion.querySelector('[data-sub-menu-accordion-trigger]');
            const isMobile = window.innerWidth < 1280;

            if (!isMobile && index === 0) {
                mobileSubMenuAccordion.querySelector('[data-sub-menu-accordion-content').classList.toggle('is-active');
            }

            trigger.addEventListener('click', () => {
                if (!isMobile) {
                    const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize); // Get root font-size in pixels
                    const parentMenu = trigger.closest('[data-header-sub-menu]');
                    const contentHeightPx = mobileSubMenuAccordion.querySelector('[data-sub-menu-accordion-content]')?.clientHeight || 0;
                    const extraHeightRem = 80 / rootFontSize; // Convert px to rem

                    if (parentMenu) {
                        parentMenu.style.height = `${(contentHeightPx / rootFontSize) + extraHeightRem}rem`;
                    }
                }

                this.closeAllSubMenuAccordions();
                trigger.classList.toggle('is-active');
                trigger.querySelector('[data-sub-menu-accordion-trigger-icon]').classList.toggle('is-active');
                mobileSubMenuAccordion.querySelector('[data-sub-menu-accordion-content').classList.toggle('is-active');
                this.toggleMobileButtonZindexes();
            });
        })

        this.toggleDesktopSubMenus.forEach(button => {
            button.addEventListener('click', (event) => {
                if (window.innerWidth >= this.desktopBreakpoint) {
                    const menu = event.target.nextElementSibling;
                    this.toggleDesktopSubMenu(menu, event);
                }
            })
        })

        // Backdrop toggle on open of search
        this.predictiveSearchToggle.forEach(toggle => {
            toggle.addEventListener('click', () => {
                this.showHeaderBackDrop();
                this.headerBackdrop.classList.add('z-10');
            })
        })

        // Backdrop toggle on close of search
        this.predictiveSearchClose.addEventListener('click', () => {
            this.headerBackdrop.classList.remove('z-10');
            const openMenus = document.querySelectorAll('div[data-header-sub-menu][aria-expanded="true"]')
            if (!openMenus || openMenus.length === 0) {
                this.removeHeaderBackDrop();
            }
        })

        // Close header and search on click of backdrop
        this.headerBackdrop.addEventListener('click', () => {
            this.setHeaderTransparentTheme();
            this.closeAllDesktopSubMenus();
            this.predictiveSearchModal.hide();
            this.removeHeaderBackDrop();
            this.headerBackdrop.classList.remove('z-10');
        })

        this.closeMobileSubMenuAccordions.forEach(button => {
            button.addEventListener('click', () => {
                const menu = button.closest('div[data-sub-menu-accordion-content]');
                menu.classList.toggle('is-active');
                this.toggleMobileButtonZindexes();
            })
        })
    }

    closeAllSubMenuAccordions () {
        this.mobileSubMenuAccordions.forEach(subMenuAccordion => {
            const trigger = subMenuAccordion.querySelector('[data-sub-menu-accordion-trigger]');
            if (trigger.classList.contains('is-active')) {
                trigger.classList.remove('is-active');
                trigger.querySelector('[data-sub-menu-accordion-trigger-icon]').classList.remove('is-active');
                subMenuAccordion.querySelector('[data-sub-menu-accordion-content').classList.remove('is-active');
            }
        })
    }

    toggleMobileTopLevelMenu (menu, button) {
        const isTopLevelLink = button?.dataset.headerTopLevel;

        if(isTopLevelLink) {
            this.closeAllMobileSubMenus();
            button.classList.add('xLargeMax:bg-primary');
            button.classList.add('xLargeMax:text-white');
            button.classList.remove('xLargeMax:text-text1');
        }

        if (!menu.classList.contains('xLargeMax:translate-x-0')) {
            menu.classList.add('xLargeMax:translate-x-0');
            menu.classList.add('xLargeMax:opacity-100');
            menu.classList.remove('xLargeMax:-translate-x-full');
            menu.classList.remove('xLargeMax:opacity-0');
        }
    }

    toggleMobileMenu (menu) {
        if (this.announcementBar) {
            // Adds offset of announcement bar to mobile menu
            this.menuMobile.style.setProperty('--announcement-bar-offset-mobile', `${Math.max(this.announcementBar.getBoundingClientRect().height - window.scrollY, 0) / 16}rem`);
        }

        if (menu.classList.contains('xLargeMax:translate-x-0')) {
            menu.classList.remove('xLargeMax:translate-x-0');
            menu.classList.remove('xLargeMax:opacity-100');
            menu.classList.add('xLargeMax:-translate-x-full');
            menu.classList.add('xLargeMax:opacity-0');
            if (menu.hasAttribute('data-sub-menu') && menu.querySelector('[data-close-sub-menu]')) {
                menu.querySelector('[data-close-sub-menu]').setAttribute('aria-expanded', false);
            }
        } else {
            menu.classList.add('xLargeMax:translate-x-0');
            menu.classList.add('xLargeMax:opacity-100');
            menu.classList.remove('xLargeMax:-translate-x-full');
            menu.classList.remove('xLargeMax:opacity-0');
            if (menu.hasAttribute('data-sub-menu') && menu.querySelector('[data-close-sub-menu]')) {
                menu.querySelector('[data-close-sub-menu]').setAttribute('aria-expanded', true);
            }
        }
    }

    toggleMobileBodyOverflow () {
        if (this.menuMobile.classList.contains('xLargeMax:translate-x-0')) {
            this.body.classList.add('xLargeMax:overflow-hidden');
        } else {
            this.body.classList.remove('xLargeMax:overflow-hidden');
        }
    }

    toggleDesktopSubMenu (menu, button) {
        const svg = button.target.querySelector('[data-desktop-menu-caret]');
        const isTopLevelLink = button.target.dataset.headerTopLevel;
        if (menu.classList.contains('xLarge:opacity-0')) {
            if (isTopLevelLink) {
                this.closeAllDesktopSubMenus(button);
            }
            menu.classList.remove('xLarge:opacity-0');
            menu.classList.remove('xLarge:invisible');
            menu.classList.remove('xLarge:h-0');
            svg.classList.add('xLarge:rotate-180');
            menu.closest('[data-sub-menu]').setAttribute('aria-expanded', true);
            button.target.classList.add('xLarge:border-primary')
            button.target.classList.remove('xLarge:border-transparent')
            this.showHeaderBackDrop();
            this.setHeaderLightTheme();
            this.stickyHeader.disconnectedCallback();
        } else {
            menu.classList.add('xLarge:opacity-0');
            menu.classList.add('xLarge:invisible');
            menu.classList.add('xLarge:h-0');
            svg.classList.remove('xLarge:rotate-180');
            menu.closest('[data-sub-menu]').setAttribute('aria-expanded', false);
            button.target.classList.remove('xLarge:border-primary');
            button.target.classList.add('xLarge:border-transparent')
            this.removeHeaderBackDrop();
            this.setHeaderTransparentTheme();
            this.stickyHeader.connectedCallback();
        }
    }

    setHeaderLightTheme () {
        this.stickyHeader.querySelector('header').classList.add('bg-uiWhite');
        this.logoHeader.classList.add('text-background1');
        this.logoHeader.classList.remove('text-uiWhite');
        this.menuMobile.classList.add('text-background1');
        this.menuMobile.classList.remove('text-uiWhite');
        this.headerIcons.classList.remove('text-accent2');
        this.headerIcons.classList.add('text-text1');
        this.toggleMenuMobileButton.classList.add('text-background1');
        this.toggleMenuMobileButton.classList.remove('text-uiWhite');
        this.mobileSearchIcon?.classList.add('text-background1');
        this.mobileSearchIcon?.classList.remove('text-uiWhite');
        document.querySelectorAll('[data-top-level-mobile]')?.forEach(btn => {
            btn.classList.add('xLarge:hover:text-primary');
            btn.classList.remove('xLarge:hover:opacity-60');
        })
    }

    setHeaderTransparentTheme (isLoad) {
        const isMobile = window.innerWidth < 1280;
        if (isLoad || !isMobile) {
            const firstSection = document.querySelector('#MainContent').children[0];
            const firstSectionCollection = firstSection.querySelector('.collection-hero');
            if (
                firstSection.classList.contains('js-section-text-over-media') ||
                firstSection.classList.contains('js-section-hero-text-over-media') ||
                firstSection.classList.contains('js-section-hero') ||
                firstSectionCollection && (firstSectionCollection.classList.contains('js-collection-banner-transparent') || firstSectionCollection.classList.contains('js-collection-banner-image')) ||
                firstSection.classList.contains('js-section-main-article')
            ) {
                this.stickyHeader.querySelector('header').classList.remove('bg-uiWhite');
                this.logoHeader.classList.remove('ttext-background1');
                this.logoHeader.classList.add('text-uiWhite');
                this.menuMobile.classList.remove('ttext-background1');
                this.menuMobile.classList.add('text-uiWhite');
                this.headerIcons.classList.add('text-accent2');
                this.headerIcons.classList.remove('text-text1');
                this.toggleMenuMobileButton.classList.add('text-uiWhite');
                this.toggleMenuMobileButton.classList.remove('text-background1');
                this.mobileSearchIcon?.classList.remove('text-background1');
                this.mobileSearchIcon?.classList.add('text-uiWhite');
                document.querySelectorAll('[data-top-level-mobile]')?.forEach(btn => {
                    btn.classList.remove('xLarge:hover:text-primary');
                    btn.classList.add('xLarge:hover:opacity-60');
                })
            }
        }
    }

    closeAllDesktopSubMenus () {
        this.desktopSubMenus.forEach(menu => {
            if (!menu.classList.contains('xLarge:opacity-0')) {
                menu.closest('[data-sub-menu]').setAttribute('aria-expanded', false);
                menu.classList.add('xLarge:opacity-0');
                menu.classList.add('xLarge:invisible');
                menu.classList.add('xLarge:h-0');
            }
        })

        this.toggleDesktopSubMenus.forEach(button => {
            if (button.classList.contains('xLarge:border-primary')) {
                button.classList.remove('xLarge:border-primary');
                button.classList.add('xLarge:border-transparent');
            }
            const svg = button.querySelector('[data-desktop-menu-caret]');
            if (svg.classList.contains('xLarge:rotate-180')) {
                svg.classList.remove('xLarge:rotate-180');
            }
        })
    }

    closeAllMobileSubMenus () {
        this.desktopSubMenus.forEach(menu => {
            if (menu.classList.contains('xLargeMax:opacity-100')) {
                menu.classList.remove('xLargeMax:opacity-100');
                menu.classList.remove('xLargeMax:translate-x-0');
                menu.classList.add('xLargeMax:-translate-x-full');
                menu.classList.add('xLargeMax:opacity-0');
            }
        })

        this.toggleMobileSubMenus.forEach(toggle => {
            if (toggle.classList.contains('xLargeMax:bg-primary')) {
                toggle.classList.remove('xLargeMax:bg-primary');
                toggle.classList.remove('xLargeMax:text-white');
                toggle.classList.add('xLargeMax:text-text1');
            }
        })
    }

    transparentHeaderCheck () {
        const firstSection = document.querySelector('#MainContent').children[0];
        if (
            firstSection.classList.contains('js-section-text-over-media') ||
            firstSection.classList.contains('js-section-hero-text-over-media') ||
            firstSection.classList.contains('js-section-hero')
        ) {
            this.setHeaderTransparentTheme(true);
        } else if (firstSection.classList.contains('js-section-collection-banner')) {
            const transparentCheck = firstSection.querySelector('.collection-hero');
            if (transparentCheck && (transparentCheck.classList.contains('js-collection-banner-transparent') || transparentCheck.classList.contains('js-collection-banner-image'))) {
                this.setHeaderTransparentTheme(true);
            } else {
                this.setHeaderLightTheme();
                this.setHeaderRelative();
            }
        } else if (firstSection.classList.contains('js-section-main-article')) {
            const transparentCheck = firstSection.querySelector('.article_hero');
            if (transparentCheck) {
                this.setHeaderTransparentTheme(true);
            } else {
                this.setHeaderLightTheme();
                this.setHeaderRelative();
            }
        } else {
            this.setHeaderLightTheme();
            this.setHeaderRelative();
        }
    }

    setHeaderRelative() {
        this.stickyHeader.classList.add('relative');
        this.stickyHeader.classList.remove('absolute');
    }

    showHeaderBackDrop () {
        this.headerBackdrop.classList.add('opacity-60');
        this.headerBackdrop.classList.add('top-0')   ;
        this.headerBackdrop.classList.remove('-top-full');
        this.headerBackdrop.classList.remove('opacity-0');
    }

    removeHeaderBackDrop () {
        this.headerBackdrop.classList.add('-top-full');
        this.headerBackdrop.classList.add('opacity-0');
        this.headerBackdrop.classList.remove('top-0');
        this.headerBackdrop.classList.remove('opacity-60');
    }

    toggleMobileButtonZindexes () {
        this.topLevelMobileButtons.forEach(button => {
            button.classList.toggle('xLargeMax:relative');
            button.classList.toggle('xLargeMax:z-20');
        })
    }
}

export default class StickyHeader extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.headerBounds = {};

        this.currentScrollTop = 0;
        this.preventReveal = false;

        this.predictiveSearch = this.querySelector('predictive-search');
        this.predictiveSearchModal = this.querySelector('modal-dialog[id=PredictiveSearch]');

        this.onScrollHandler = this.onScroll.bind(this);
        this.hideHeaderOnScrollUp = () => this.preventReveal = true;

        this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.addEventListener('scroll', this.onScrollHandler, false);

        this.createObserver();
    }

    disconnectedCallback() {
        this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
        window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
        let observer = new IntersectionObserver((entries, observer) => {
            this.headerBounds = entries[0].intersectionRect;
            observer.disconnect();
        });

        observer.observe(this.header);
    }

    onScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearchModal && this.predictiveSearchModal.classList.contains('is-active')) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (this.preventHide) return;
            window.requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
            if (!this.preventReveal) {
                window.requestAnimationFrame(this.reveal.bind(this));
            } else {
                window.clearTimeout(this.isScrolling);

                this.isScrolling = setTimeout(() => {
                    this.preventReveal = false;
                }, 66);

                window.requestAnimationFrame(this.hide.bind(this));
            }
        } else if (scrollTop <= this.headerBounds.top) {
            window.requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
    }

    hide() {
        this.header.classList.add('-translate-y-full', 'overflow-hidden', 'sticky', 'top-0', 'z-30');
        this.closeMenuDisclosure();
    }

    reveal() {
        this.header.classList.add('header-is-sticky', 'sticky', 'top-0', 'z-30');
        this.header.classList.remove('-translate-y-full', 'overflow-hidden');
    }

    reset() {
        this.header.classList.remove('header-is-sticky', '-translate-y-full', 'overflow-hidden', 'sticky', 'top-0', 'z-30', 'transition-[transform_0.15s_ease-out]');
    }

    closeMenuDisclosure() {
        this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
        this.disclosures.forEach(disclosure => disclosure.close());
    }
}

export {
    Header,
    StickyHeader
}
